var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.temAlgoParaMostrar
    ? _c(
        "div",
        _vm._b(
          {
            staticClass: "grafico-do-turno ia-block-card",
            attrs: { "data-test": "grafico-do-turno" }
          },
          "div",
          _vm.MOLDURA_DO_THREAD,
          false
        ),
        [
          _c(
            "div",
            {
              staticClass:
                "ia-block-card__cabecalho ia-block-card__cabecalho--fita"
            },
            [
              _c("icon-svg", {
                staticClass: "ia-block-card__icone",
                attrs: { name: "chart-bar", size: 14, color: "var(--primary)" }
              }),
              _c("span", { staticClass: "ia-block-card__titulo" }, [
                _vm._v(_vm._s(_vm.GRAFICO_DO_TURNO.TITULO))
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "grafico-do-turno__corpo" },
            _vm._l(_vm.itens, function(item) {
              return _c(
                "div",
                {
                  key: item.chave,
                  staticClass: "grafico-do-turno__item",
                  attrs: { "data-test": "grafico-do-turno-item" }
                },
                [
                  item.carregando
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "grafico-do-turno__estado ia-texto-auxiliar"
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.GRAFICO_DO_TURNO.CARREGANDO) + " "
                          )
                        ]
                      )
                    : _vm._e(),
                  item.dataUrl
                    ? _c("img", {
                        staticClass: "grafico-do-turno__imagem",
                        attrs: {
                          src: item.dataUrl,
                          alt: item.nome,
                          "data-test": "grafico-do-turno-imagem"
                        }
                      })
                    : _vm._e(),
                  item.dataUrl
                    ? _c(
                        "div",
                        { staticClass: "grafico-do-turno__acoes" },
                        [
                          _c(
                            "BaseButton",
                            {
                              attrs: {
                                underlined: "",
                                "aria-label": item.rotuloBaixar,
                                "data-test": "grafico-do-turno-baixar"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.baixar(item.chave)
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(item.rotuloBaixar) + " ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  item.falhou
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "grafico-do-turno__estado ia-texto-auxiliar grafico-do-turno__estado--falha",
                          attrs: {
                            role: "alert",
                            "data-test": "grafico-do-turno-falha"
                          }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.GRAFICO_DO_TURNO.NAO_SAIU) + " "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            }),
            0
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }